// @flow

import styled, { css } from 'styled-components';
import React from 'react';
import Observer from 'react-intersection-observer';
import type { Theme } from '../../../types';
import { svgEncode } from '../../../helpers';
import Icon from '../assets/car_medium.svg';

const centerObject = css`
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
`;

type ContainerProps = {
  isReserved: boolean,
};
export const ImageContainer = styled<any, Theme, ContainerProps>('section')`
  position: relative;

  img {
    max-height: 100%;
    max-width: 100%;
    transition: transform .3s ease;
    ${centerObject}

    ${props => props.isReserved && css`
      filter: blur(1px) grayscale(.75);
    `}

  }
`;

const Reserved = styled<any, Theme>('span')`
  color: white;
  font-size: 1.25rem;
  font-weight: 600;
  text-shadow: 0 0 2px hsla(0, 0%, 0%, .8);
  ${centerObject}
`;

type Props = {
  src: string,
  alt: string,
  isReserved: boolean,
  reservedText: string,
};

const CarBlockImage = ({
  src, alt, reservedText, isReserved,
}: Props) => (
  <ImageContainer isReserved={isReserved}>
    <Observer rootMargin="0px 0px 250px 0px" triggerOnce>
      {({ inView, ref }) => {
        if (inView) {
          return (<img src={src} alt={alt} ref={ref} />);
        }
        return (<img src={`data:image/svg+xml;utf8,${svgEncode(Icon)}`} alt={alt} ref={ref} />);
      }}
    </Observer>
    {isReserved && <Reserved>{reservedText}</Reserved>}
  </ImageContainer>
);

export default CarBlockImage;
